module.exports = __webpack_public_path__ + "img/app.02a6bef6.png";